import { useTranslation } from 'react-i18next';
import { useState, useRef, FormEvent, ChangeEvent } from 'react';
import { InfoBlock } from 'app/components';
import Modal, { ModalContentWrapper, OldModalHandle } from 'shared/overlays/OldModal';
import { useChangePassword as useChangePasswordMutation } from 'entities/user';

const ChangePassword = () => {
  const { t } = useTranslation(['common', 'my-profile']);

  const modal = useRef<OldModalHandle>(null);

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword1, setNewPassword1] = useState('');
  const [newPassword2, setNewPassword2] = useState('');
  const { mutate: changePassword, isPending: busy } = useChangePasswordMutation();

  const handleClickEdit = () => {
    modal.current?.open();
  };

  const handleClickCancel = () => {
    modal.current?.close();
  };

  const handleSubmitForm = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    changePassword(
      { currentPassword, newPassword1, newPassword2 },
      {
        onSuccess: (response) => {
          if (response.status === 204) {
            modal.current?.close();
            setCurrentPassword('');
            setNewPassword1('');
            setNewPassword2('');
          }
        },
      }
    );
  };

  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center">
          <h2 className="my-0">{t('my-profile:password.title')}</h2>
          <button className="btn btn-secondary btn-sm" onClick={handleClickEdit}>
            {t('my-profile:change-password.title')} <i className="ms-2 fa-regular fa-gear" />
          </button>
        </div>
        <InfoBlock caption={t('my-profile:password')} text="********" />
      </div>
      <Modal ref={modal}>
        <ModalContentWrapper titleLabelKey="my-profile:password.modal.title">
          <form onSubmit={handleSubmitForm}>
            <div className="mb-4">
              <label htmlFor="currentPassword" className="form-label">
                {t('my-profile:current-password')}
              </label>
              <input
                type="password"
                id="currentPassword"
                className="form-control"
                value={currentPassword}
                placeholder={t('my-profile:current-password')}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setCurrentPassword(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <label htmlFor="newPassword1" className="form-label">
                {t('my-profile:new-password-1')}
              </label>
              <input
                type="password"
                id="newPassword1"
                className="form-control"
                value={newPassword1}
                placeholder={t('my-profile:new-password-1')}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setNewPassword1(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <label htmlFor="newPassword2" className="form-label">
                {t('my-profile:new-password-2')}
              </label>
              <input
                type="password"
                id="newPassword2"
                className="form-control"
                value={newPassword2}
                placeholder={t('my-profile:new-password-2')}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setNewPassword2(e.target.value)}
              />
            </div>

            <div className="d-flex justify-content-end">
              <button className="btn btn-default" type="button" onClick={handleClickCancel}>
                {t('common:cancel')}
              </button>
              <button className="btn btn-primary">
                {busy ? <i className="fa-regular fa-spinner fa-spin" /> : null} {t('common:save')}
              </button>
            </div>
          </form>
        </ModalContentWrapper>
      </Modal>
    </div>
  );
};

export default ChangePassword;
